export default "__VITE_ASSET__90e41101__"